/** Figma / Unicode BLACK CIRCLE — same glyph in DOM + mirror so caret width matches. */
export const HP_PW_BULLET = '\u25CF';

/**
 * Derives the real password from the raw input value while the field displays only ●.
 * Keeps caret aligned because each position uses the same advance width as the mirror.
 */
export function derivePasswordFromMaskedInput(raw: string, oldPwd: string): string {
  const B = HP_PW_BULLET;
  if (!raw) {
    return '';
  }
  if (!raw.includes(B)) {
    return raw;
  }
  const n = oldPwd.length;
  const oldMask = B.repeat(n);

  if (n > 0 && raw.length === n - 1 && raw === B.repeat(n - 1)) {
    return oldPwd.slice(0, -1);
  }

  if (n > 0 && raw.length < n && raw === B.repeat(raw.length)) {
    return oldPwd.slice(0, raw.length);
  }

  if (raw.startsWith(oldMask) && raw.length > oldMask.length) {
    const typed = raw.slice(oldMask.length).replace(new RegExp(B, 'g'), '');
    return oldPwd + typed;
  }

  return oldPwd;
}

export function applyBulletMaskToInput(el: HTMLInputElement, pwd: string): void {
  const m = HP_PW_BULLET.repeat(pwd.length);
  const end = pwd.length;
  if (el.value !== m) {
    el.value = m;
  }
  requestAnimationFrame(() => {
    try {
      if (el.selectionStart !== end || el.selectionEnd !== end) {
        el.setSelectionRange(end, end);
      }
    } catch {
      /* ignore */
    }
  });
}
